import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useHistory } from 'react-router-dom'

import MaskedPin from 'components/MaskedPin'

import { posAccountsUtils } from 'components/PosAccounts/utils'

const Item = ({
  name,
  pinNumber,
  deactivatedAt,
  employeeRole,
  uuid,
}) => {
  const history = useHistory()

  const displayName = isEmpty(name) ? 'unknown' : name
  const displayStatus = isEmpty(deactivatedAt) ? 'Active' : 'Inactive'
  const transformedEmployeeRole =
    posAccountsUtils.transformEmployeeRoleToDisplay(employeeRole)

  const onClickItem = () => {
    history.push({ state: { posAccountUuid: uuid } })
  }

  return (
    <div className="item" onClick={onClickItem} role="button">
      <div className="row">
        <div className="item-info-wrapper font-weight-bold">
          {displayName}
        </div>
        <div className="item-info-wrapper">
          <span className="-truncate-text-lg">
            {transformedEmployeeRole}
          </span>
        </div>
        <div className="item-info-wrapper">
          <span className="-truncate-text-lg">
            {<MaskedPin pin={pinNumber} />}
          </span>
        </div>
        <div className="item-info-wrapper">
          <span
            className={cn('item-type__dot', {
              '-on': displayStatus === 'Active',
              '-off': displayStatus === 'Inactive',
            })}
          ></span>
          {displayStatus}
        </div>
      </div>
    </div>
  )
}

Item.propTypes = {
  name: PropTypes.string,
  pinNumber: PropTypes.string,
  deactivatedAt: PropTypes.string,
  roles: PropTypes.array,
  uuid: PropTypes.string,
}

export default Item
